export default __webpack_public_path__ + "static/media/office-edit2.d6e5ce8b.png";